import type { RecipeSummaryCard } from 'services/recipes/types';
import config from 'config';

const LEGACY_RECIPE_PATH = '/content/waitrose/en/home/recipes';

export const recipeURL = ({ isLegacy, url }: RecipeSummaryCard) =>
  isLegacy && url.includes(LEGACY_RECIPE_PATH) ? `https://www.waitrose.com${url}` : url;

export const selectImage = (recipe: RecipeSummaryCard) => {
  const image = recipe.images?.[0];

  if (recipe.isLegacy && (recipe.url ?? '').includes(LEGACY_RECIPE_PATH)) {
    if (image?.fileReference?.includes('Recipe_image_on_its_way.jpg')) {
      return `${config.cfDomain}${image?.fileReference}`;
    }

    return `https://www.waitrose.com${image?.fileReference}.thumb.400.400.png`;
  }

  return image?.dynamicImages?.highQuality95 || `${config.cfDomain}${image?.fileReference}`;
};
